uniform float uTime;
uniform float uDeltaTime;
uniform vec3 uMouse;
uniform float uMouseRadius;
uniform float uMouseAspect;
uniform float uSuckAmount;
uniform float uSuckStrength;
uniform vec3 uMouseVelocity;
uniform float uWindStrength;
uniform float uDamping;
uniform float uTurbulenceStrength;
uniform float uTurbulenceFrequency;
uniform float uFlowFieldFrequency;
uniform float uFlowFieldStrength;
uniform float uFlowFieldInfluence;
uniform sampler2D uBase;

#include ../includes/simplexNoise4d.glsl

// Rectangular distance: returns 0..1 normalized distance inside the box
float rectDist(vec3 pos, vec3 center, float radius, float aspect)
{
    vec3 d = abs(pos - center);
    // Horizontal half-size is stretched by aspect, vertical is compressed
    float dx = d.x / (radius * aspect);
    float dy = d.y / (radius / aspect);
    float dz = d.z / radius;
    return max(max(dx, dy), dz);
}

void main()
{
    float time = uTime * 0.2;
    vec2 uv = gl_FragCoord.xy / resolution.xy;
    vec4 velocity = texture(uVelocity, uv);
    vec4 particle = texture(uParticles, uv);
    vec4 base = texture(uBase, uv);

    // Reset velocity when particle is dead
    if(particle.a >= 1.0)
    {
        velocity.xyz = vec3(0.0);
        gl_FragColor = velocity;
        return;
    }

    // Flow field force
    float strength = simplexNoise4d(vec4(base.xyz * 0.2, time + 1.0));
    float influence = (uFlowFieldInfluence - 0.5) * (-2.0);
    strength = smoothstep(influence, 1.0, strength);

    vec3 flowField = vec3(
        simplexNoise4d(vec4(particle.xyz * uFlowFieldFrequency + 0.0, time)),
        simplexNoise4d(vec4(particle.xyz * uFlowFieldFrequency + 1.0, time)),
        simplexNoise4d(vec4(particle.xyz * uFlowFieldFrequency + 2.0, time))
    );
    flowField = normalize(flowField);
    velocity.xyz += flowField * strength * uFlowFieldStrength * uDeltaTime * (1.0 - uSuckAmount);

    // Mouse wind force (circular)
    float mouseSpeed = length(uMouseVelocity);
    if(uSuckAmount < 0.1 && mouseSpeed > 0.1)
    {
        float dist = length(particle.xyz - uMouse);
        if(dist < uMouseRadius)
        {
            float proximity = smoothstep(uMouseRadius, 0.0, dist);
            velocity.xyz += uMouseVelocity * proximity * uWindStrength * uDeltaTime;
        }
    }

    // Suck toward mouse (when clicking)
    if(uSuckAmount > 0.01)
    {
        float rd = rectDist(particle.xyz, uMouse, uMouseRadius, uMouseAspect);
        if(rd < 1.0)
        {
            vec3 toMouse = uMouse - particle.xyz;
            vec3 suckDir = normalize(toMouse);
            float proximity = smoothstep(1.0, 0.0, rd);
            velocity.xyz += suckDir * proximity * uSuckAmount * uSuckStrength * uDeltaTime;
        }
    }

    // Turbulence
    vec3 turbulence = vec3(
        simplexNoise4d(vec4(particle.xyz * uTurbulenceFrequency, time * 3.0 + 10.0)),
        simplexNoise4d(vec4(particle.xyz * uTurbulenceFrequency, time * 3.0 + 20.0)),
        simplexNoise4d(vec4(particle.xyz * uTurbulenceFrequency, time * 3.0 + 30.0))
    );
    velocity.xyz += turbulence * uTurbulenceStrength * uDeltaTime;

    // Damping
    velocity.xyz *= (1.0 - uDamping * uDeltaTime);

    gl_FragColor = velocity;
}
